/** Поля позиции, из которых собирается подпись размера. */
export interface ProductSizeSource {
  size?: string | null;
  volume?: number | null;
  weight?: number | null;
}

/**
 * Подпись размера позиции: «50см», «500 мл», «320 г».
 *
 * Одна функция на всю корзину: карточка товара и состав комбо должны подписывать
 * одну и ту же пиццу одинаково, иначе гость видит «Ветчина и грибы 50см» в одной строке
 * и просто «Ветчина и грибы» в другой — и не понимает, что заказал.
 *
 * Приоритет у `size`: в меню он уже человеческий («50см», «Большая»), тогда как объём
 * и вес — числа. Объём и вес идут запасным вариантом для позиций без размера (напитки,
 * закуски). Дублировать их к размеру нельзя: размер часто уже содержит объём строкой
 * («300мл.»), и вышло бы «300мл. · 300 мл».
 */
export function productSizeLabel(source: ProductSizeSource | null | undefined): string {
  if (!source) return '';

  const size = source.size?.trim();
  if (size) return size;

  if (source.volume) return `${source.volume} мл`;
  if (source.weight) return `${source.weight} г`;

  return '';
}

/** Вариант в переключателе: те же поля плюс имя как последний запасной вариант. */
export interface ProductVariantLabelSource extends ProductSizeSource {
  name?: string | null;
}

/**
 * Подпись кнопки в переключателе вариантов: «50см», «Куриной», «500 мл».
 *
 * От productSizeLabel отличается только хвостом: если ни размера, ни объёма, ни веса
 * нет, показываем имя — пустая кнопка хуже неточной. Брать имя ПЕРВЫМ нельзя: у
 * напитков варианты одной линейки называются одинаково («Кола» 0,5 и «Кола» 1 л,
 * объём лежит в volume), и гость увидел бы две неразличимые кнопки.
 */
export function productVariantLabel(
  variant: ProductVariantLabelSource | null | undefined,
): string {
  return productSizeLabel(variant) || variant?.name?.trim() || '';
}
